angular.module('myappointments').config(['AppRoutesProvider', '$stateProvider', '$urlRouterProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'appointments' };

        var appRoutes = {
            'myAppointments': {
                state: 'myAppointments',
                route: '/my-appointments',
                portalSettings: portalSettings
            },
            'editRequestedAppointment': {
                state: 'editRequestedAppointment',
                route: '/requested-appointment-edit',
                portalSettings: portalSettings
            },
            'addRequestedAppointment': {
                state: 'addRequestedAppointment',
                route: '/requested-appointment-add',
                portalSettings: portalSettings
            },
            'confirmRequestedAppointment': {
                state: 'confirmRequestedAppointment',
                route: '/requested-appointment-confirm',
                portalSettings: portalSettings
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.myAppointments.state, {
                url: appRoutes.myAppointments.route,
                templateUrl: '/myappointments/views/myAppointments.html',
                controller: 'MyAppointmentsCtrl',
                description: '/myAppointments',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Appointments'); }
                }
            })
            .state(appRoutes.editRequestedAppointment.state, {
                url: appRoutes.editRequestedAppointment.route,
                templateUrl: '/myappointments/views/scheduleAppointment.html',
                controller: 'ScheduleAppointmentCtrl',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Schedule An Appointment'); }
                }
            })
            .state(appRoutes.addRequestedAppointment.state, {
                url: appRoutes.addRequestedAppointment.route,
                templateUrl: '/myappointments/views/scheduleAppointment.html',
                controller: 'ScheduleAppointmentCtrl',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Schedule An Appointment'); }
                }
            })
            .state(appRoutes.confirmRequestedAppointment.state, {
                url: appRoutes.confirmRequestedAppointment.route,
                templateUrl: '/myappointments/views/confirmAppointment.html',
                controller: 'ConfirmAppointmentCtrl',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Appointments'); }
                }
            });
    }]);